import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';
import { obterContratosRequest } from '@store/emprestimo/actions';
import { LoadingIndicator } from '@components';

import { Alerta } from './Alerta';
import { Contrato } from './contrato';

const ListaContratosAbertos = () => {
  const dispatch = useDispatch();
  const requestDone = useSelector(
    (state) => state.emprestimo.obterContratosDone
  );

  const { contratos, totalParcelasEmAtraso } = useSelector(
    (state) => state.emprestimo
  );

  useEffect(() => {
    dispatch(obterContratosRequest());
  }, [dispatch]);

  return (
    <div className="card">
      <div className="card-body">
        {!requestDone ? (
          <LoadingIndicator />
        ) : (
          <>
            {totalParcelasEmAtraso > 0 && (
              <>
                <Alerta />
                <hr />
              </>
            )}
            {contratos.map((contrato) => (
              <Fragment key={contrato.contrato}>
                <Contrato contrato={contrato} />
              </Fragment>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export const ContratosAbertos = () => {
  const [shouldShowSubPage, setShouldShowSubPage] = useState(false);
  const params = useParams();

  useEffect(() => {
    setShouldShowSubPage(!!params?.id);
  }, [params?.id]);

  return shouldShowSubPage ? <Outlet /> : <ListaContratosAbertos />;
};
